import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import flashIcon from "../../assets/images/flash_icon.svg";
import checkCircle from "../../assets/images/check_circle.svg";
import markCircle from "../../assets/images/mark_circle.svg";
import checkMark from "../../assets/images/check_small.svg";
import load from "../../assets/images/rotate.svg";
import { Button } from "react-bootstrap";
import Loader from "../loader/Loader";
import strings from "../../resources/strings.json";
import "./VoluntaryTOffComponent.scss";
import moment from "moment";
import aboutRed from "../../assets/images/about_icon_red.svg";

const ConfirmationPopUp = (props) => {

    const {
        title,
        headers,
        showModal,
        selectedList,
        availableDates,
        handleConfirmationRequest,
        setShowModal,
        showConfirmationLoader,
        confirmedBatch,
        showConfirmData,
        batchSubmitted,
        cleanUpBatch,
        recallEmployeeBatch,
    } = props;

    const history = useHistory();

    const reOrderPerDate = (list) => {
        let orderedList = [];
        for (let i = 0; i < availableDates.length ; i++) {
            let currentDate = availableDates[i];
            let offersPerDate = list.filter(offer=> {
                return offer.offerDate == currentDate;
            })
            orderedList.push({currentDate, requests : offersPerDate});
        }
        return orderedList;
     }
     
    const [confirmationList, setConfirmationList] = useState([]);

    const checkConfirmation = (offerId, vtoID) => {
        //vtoId is in shift but shift.id is being passed
        if(title === "Employee Request Summary"){
            if (batchSubmitted?.response) {
                return batchSubmitted.response?.[offerId]?.response?.toUpperCase() === "SUCCESS";
            }
            else{
                return confirmedBatch?.[vtoID]?.response?.toUpperCase() === "SUCCESS";
            }
        }
        else if ( title == "Request Summary" ) {
            if (confirmedBatch[offerId]?.response.toUpperCase() == "SUCCESS") {
                return true
            } else {
                return false
            }
        }
         else {
            if (batchSubmitted.response[offerId]?.response.toUpperCase() == "SUCCESS") {
                return true
            } else {
                return false
            }
         }
    }

    const handleGoToMyRequests = () => {
        history.push({
                pathname: title == "Request Summary" || title == "Employee Request Summary" ? "/VTO_my_requests" : "/vtoAdminRequests",
              })
        setShowModal(false)
    }

    const isOvernight = (startTime, endTime) => {
        const start = moment(startTime, "HH:mm");
        const end = moment(endTime, "HH:mm");
        // If end time is earlier than start time, it means the shift goes overnight
        return end.isBefore(start);
    }
    
    useEffect(()=>{
        setConfirmationList(reOrderPerDate(selectedList.length > 0 ? selectedList : batchSubmitted))
    },[selectedList, batchSubmitted])

    return (

        <Modal id="confirmation-modal"
        show={showModal}>
            <Modal.Title className="popup-title">
                {title}
            </Modal.Title>
            <Modal.Body style={{margin: "0px 20px 20px 20px"}}>
                <table className="confirmation-modal">
                    <thead>
                        <tr>
                        {headers.map((header, index) => (
                            <th key={index} className={`confirmation-date ${header.className || ''}`}>
                                {header}
                            </th>
                        ))}
                        </tr>
                    </thead>
                    <tbody>
                        {title == "Request Summary" ? 
                        confirmationList.map((req, idx)=> {
                        if (req.requests.length> 0) {
                        return <>
                            {req.requests.map((reqItem, i) => {
                            return<>
                            <tr className="confimation-body">
                                <td>
                                {showConfirmData ? (
                                    checkConfirmation(reqItem.offerId) ? (
                                    <span className="confirmed">
                                        <img src={checkCircle} style={{width: "fit-content"}}  alt="Confirmed" />Sent
                                    </span>
                                    ) : (
                                    <span className="error">
                                        <img src={markCircle} alt="Error" style={{ paddingRight: 2, paddingLeft: 2 }} />Error
                                    </span>
                                    )
                                ) : showConfirmationLoader ? (
                                    <img className="loader-rotate" src={load} alt="Loading" />
                                ) : (
                                    <img src={checkMark} alt="Check" style={{ paddingRight: 2, paddingLeft: 2 }} />
                                )}
                                </td>
                                <td style={{textAlign: 'left'}}>{reqItem.flashOffer== 1&&<img src={flashIcon}/>}</td>
                                <td className="confirmation-date" >
                                    <span>
                                        {reqItem.offerDate} {reqItem.empShiftStartTime} - {reqItem.empShiftEndTime}
                                    </span>
                                    {isOvernight(reqItem.offerStartTime, reqItem.offerEndTime) &&<>
                                            <span style={{color:'#0078d2'}}>*</span>
                                            <br/>
                                            <p className="end-date-note" style={{color:'#0078d2'}}>*Offer Ends {reqItem.offerEndDate}</p>
                                    </>}</td>
                                <td className="confirmation-date" >
                                    <span>
                                        {reqItem.offerStartTime} - {reqItem.offerEndTime}
                                    </span>
                                    {isOvernight(reqItem.offerStartTime, reqItem.offerEndTime) &&<>
                                            <span style={{color:'#0078d2'}}>*</span>
                                            <br/>
                                            <p className="end-date-note" style={{color:'#0078d2'}}>*Offer Ends {reqItem.offerEndDate}</p>
                                    </>}

                                        </td>
                                {/* <td className="confirmation-date" >{reqItem.empVtoStartTime} - {reqItem.empVtoEndTime}</td> */}
                                <td className="confirmation-date">{reqItem.employeeVTOHours}</td>
                                <td className="confirmation-date">{reqItem.classification}</td>
                                <td className="confirmation-date">{reqItem.dutyAssignment}</td>
                            </tr>
                            {showConfirmData&& !checkConfirmation(reqItem.offerId) &&
                                <td className="confirmation-date error" colSpan="5">{confirmedBatch[reqItem.offerId]?.message}</td>}
                            </>
                            })}</>
                        }}):
                        
                        selectedList.length>0 && selectedList.map(offer=>{
                        return offer.shifts.map((shift, i)=>{
                            if (!shift) return;
                          return  <><tr className="confimation-body">
                                 <td>
                                    {showConfirmData ? (
                                    checkConfirmation(shift.id, shift.vtoId) ? (
                                    <span className="confirmed">
                                        <img src={checkCircle} style={{width: "fit-content"}} alt="Confirmed" />Sent
                                    </span>
                                    ) : (
                                    <span className="error">
                                        <img src={markCircle} alt="Error" style={{ paddingRight: 2, paddingLeft: 2 }} />Error
                                    </span>
                                    
                                    )
                                ) : showConfirmationLoader ? (
                                    <img className="loader-rotate" src={load} alt="Loading" />
                                ) : (
                                    <img src={checkMark} alt="Check" style={{ paddingRight: 2, paddingLeft: 2 }} />
                                )}
                                 </td>
                                <td style={{textAlign: 'left'}}>{offer.date==moment().format("MM/DD/YYYY")&&<img src={flashIcon}/>}</td>
                      
                                <td className="slots" >
                                     <span>
                                       {offer.date} {shift.startTime} - {shift.endTime}
                                    </span>
                                    {isOvernight(shift.startTime,shift.endTime) &&<>
                                            <span style={{color:'#0078d2'}}>*</span>
                                            <br/>
                                            <p className="end-date-note" style={{color:'#0078d2'}}>{`*Offer Ends ${moment(offer.date).add(1, 'days').format("MM/DD/YYYY")}`} </p>
                                    </>}
                                </td>
                                {shift.offerStartTime && shift.offerEndTime && <td className="slots" >
                                    <span>
                                        {shift.offerStartTime} - {shift.offerEndTime}
                                    </span>
                                    {isOvernight(shift.offerStartTime, shift.offerEndTime) &&<>
                                            <span style={{color:'#0078d2'}}>*</span>
                                            <br/>
                                            <p className="end-date-note" style={{color:'#0078d2'}}>{`*Offer Ends ${moment(offer.date).add(1, 'days').format("MM/DD/YYYY")}`} </p>
                                    </>}
                                </td>}
                                {shift.duration&&<td className="slots">{shift.duration}</td>}
                                {shift.slots&&<td className="slots" >{shift.slots}</td>}
                                {shift.workLocation&&<td className="slots" >{shift.workLocation}</td>}
                                {shift.classification&&<td className="slots" >{shift.classification}</td>}
                                {shift.dutyAssignment&&<td className="slots" >{shift.dutyAssignment}</td>}
                                <td className="slots" >{shift.offerId || "-"}</td>
                                {shift.cutOffTime&&<td className="slots">{shift.untilDepleted ? "Until Depleted" : shift.cutOffTime}</td>}
                        </tr>
                            {showConfirmData&& !checkConfirmation(offer.id) &&
                                <td className="confirmation-date error" colSpan="5">{confirmedBatch[offer.id]?.message}</td>
                            }
                            </>
                        })})
                    }
                    </tbody>
                </table>
                <div>
                    {!showConfirmData&&<div className="subheader" style={{marginTop: 30, paddingLeft: 10}}>
                    {`Total ${title == "Request Summary" ? "Requests" : "Offers"} : ${
                        title == "Request Summary"
                            ? confirmationList.reduce((acc, req) => acc + (req.requests ? req.requests.length : 0), 0)
                            : selectedList.reduce((acc, offer) => acc + (offer.shifts ? offer.shifts.length : 0), 0)
                    }`}
                    </div>}
                    {title == "Request Summary" && <div style={{display: "flex", alignItems: "center", marginTop: 20}}>
                        <img src={aboutRed}/>
                        <p className="disclaimer-vto" style={{margin:0}}>Requests submitted without confirming resolved shift trades may be delayed or rejected.</p>
                    </div>}
                    </div>
            </Modal.Body>
                {
                showConfirmData?
                <Modal.Footer className="modal-footer close">
                    <Button
                        className='button-regular'
                        onClick={()=>{
                            setShowModal(false);
                            cleanUpBatch();
                            if (typeof recallEmployeeBatch === 'function') recallEmployeeBatch();
                        }}
                        > Close
                    </Button>
                    <Button
                        className='button-regular'
                        onClick={()=> {
                            handleGoToMyRequests()
                            cleanUpBatch();
                            if (typeof recallEmployeeBatch === 'function') recallEmployeeBatch();
                        }}
                        > {`${title == "Request Summary" || title == "Employee Request Summary" ? strings.myVTO : "My Offers"} >>`}
                    </Button>
                    </Modal.Footer>
                    :
                    <Modal.Footer className="modal-footer">
                    <Button
                        className='button-regular'
                        onClick={()=>{
                            setShowModal(false);
                        }}
                        > Cancel
                            </Button>
                            <Button
                        className="button-regular confirm"
                        onClick={()=>{
                            handleConfirmationRequest()
                        }}
                        > Confirm
                            </Button>
                </Modal.Footer>
                }
            
        </Modal>
    )
};

export default ConfirmationPopUp;